import newsImage from '../../../assets/images/news1.webp';
import wxContactImage from '../../../assets/images/wx_contact.jpg';

export default function NewsSection() {
  const news = [
    {
      date: {
        day: '13',
        month: 'July',
        year: '2025'
      },
      title: '产教融合丨万江环境赴上海城建设计集团开展交流',
      excerpt: '7 月 11 日，徐强董事长带领万江环境科研、智慧环境等部门人员，赴上海城建设计总院交流，探索技术合作，为技术研发、人才培养合作铺路，助推行业发展。',
      category: '公司荣誉',
      link: 'https://mp.weixin.qq.com/s?__biz=MzcwOTEzNTQ0Nw==&mid=2247532096&idx=1&sn=631f04e4af6ed03557b91eb388f35c2c&source=41&poc_token=HCPQ1Wqjnky6BSxxujpWXUAoBnZVWVeNMg3r2VJD',
      featured: true
    },
    {
      date: {
        day: '03',
        month: 'Oct',
        year: '2025'
      },
      title: '董事长徐强受邀参加中青企协学习贯彻党的二十届三中全会精神轮训班',
      excerpt: '中青企协二十届三中全会精神轮训班举办，上海万江环境董事长徐强受邀参训，借交流把握政策趋势，助力公司战略与环保产业高质量发展。',
      category: '产品发布',
      link: 'https://mp.weixin.qq.com/mp/wappoc_appmsgcaptcha?poc_token=HF_Q1WqjwNckl4s8XQUgBjjA955jqcWeSP0nKVYk&target_url=https%3A%2F%2Fmp.weixin.qq.com%2Fs%3F__biz%3DMzcwOTEzNTQ0Nw%3D%3D%26mid%3D2247532108%26idx%3D1%26sn%3D61954c2f103cee8112e7f93708345b52%26source%3D41#wechat_redirect'
    },
    {
      date: {
        day: '23',
        month: 'Sep',
        year: '2025'
      },
      title: '《城镇排水管渠在线监测技术标准》宣贯会顺利召开，万江环境参编',
      excerpt: '《城镇排水管渠在线监测技术标准》宣贯培训会沪上召开，该标准 3 月发布 9 月实施。上海万江环境作为参编单位参与制定，标准适用于上海管渠监测设计等全环节。',
      category: '项目动态',
      link: 'https://mp.weixin.qq.com/s/IefHL2UKp0FqaWkaOsvhzwhttps://mp.weixin.qq.com/s?__biz=MzcwOTEzNTQ0Nw==&mid=2247532173&idx=1&sn=fe04f2b56511a8a0ffa550f23ecd3469&source=41&poc_token=HIDQ1WqjecI2l8M7bLhyhoABCrE7MTa7CRjDFYxT'
    },
    {
      date: {
        day: '17',
        month: 'Sep',
        year: '2025'
      },
      title: '喜报丨万江企业一号湾产教融合科创基地正式动工',
      excerpt: '热烈庆祝万江企业一号湾产教融合科技创新基地正式动工。',
      category: '合作签约',
      link: 'https://mp.weixin.qq.com/s?__biz=MzcwOTEzNTQ0Nw==&mid=2247532104&idx=1&sn=e9a6eea1ca326441c725528a1e944122&source=41&poc_token=HJPQ1WqjbT-Shu95nrQYfCvIJNPx85nXmv9eV7Tw'
    },
    // {
    //   date: {
    //     day: '12',
    //     month: 'Nov',
    //     year: '2024'
    //   },
    //   title: '参展2024中国国际环保展览会，展示最新水处理技术成果',
    //   excerpt: '绿源环保科技在2024中国国际环保展览会上精彩亮相，展示了公司在水处理技术方面的最新成果，吸引了众多客户和合作伙伴的关注。',
    //   category: '展会活动',
    //   link: 'https://mp.weixin.qq.com/s/example5'
    // },
    // {
    //   date: {
    //     day: '05',
    //     month: 'Nov',
    //     year: '2024'
    //   },
    //   title: '公司通过ISO 14001环境管理体系认证',
    //   excerpt: '经过严格的审核评估，绿源环保科技成功通过ISO 14001环境管理体系认证，标志着公司在环境管理方面达到了国际先进水平。',
    //   category: '资质认证',
    //   link: 'https://mp.weixin.qq.com/s/example6'
    // }
  ];

  // const getCategoryColor = (category: string) => {
  //   const colors: { [key: string]: string } = {
  //     '公司荣誉': 'bg-yellow-500',
  //     '产品发布': 'bg-green-500',
  //     '项目动态': 'bg-blue-500',
  //     '合作签约': 'bg-purple-500',
  //     '展会活动': 'bg-pink-500',
  //     '资质认证': 'bg-indigo-500'
  //   };
  //   return colors[category] || 'bg-gray-500';
  // };

  return (
   <section id="news" className="py-8 md:py-16 bg-gray-50 news-section">
  <div className="container mx-auto px-4 sm:px-6 lg:px-8">
    {/* 标题区保持不变 */}
    <div className="text-center mb-12 md:mb-16">
      <h2 className="text-[clamp(1.5rem,3vw,2.5rem)] font-bold text-gray-900 mb-6">
        新闻动态
      </h2>
      <p className="text-[clamp(0.875rem,1.5vw,1.125rem)] text-gray-600 max-w-3xl mx-auto leading-relaxed">
        关注万江环境科技最新动态，了解我们在水环境治理领域的创新成果和发展历程
      </p>
    </div>

    {/* 新闻内容区 */}
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-[clamp(1rem,2vw,1.5rem)]">
      {/* 主要新闻（左侧）—— 核心调整区域 */}
      <div className="lg:col-span-5">
        {news.filter(item => item.featured).map((item, index) => (
          <div key={index} className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
            {/* 主要新闻图片容器：按图片宽高比动态计算高度，确保完整显示 */}
            <div className="relative w-full" style={{ 
              // 假设图片宽高比为4:3（可根据实际图片比例调整，如16:9则设为75%）
              paddingTop: '75%', // 高度=宽度×0.75，固定宽高比
              position: 'relative'
            }}>
              <img
                src={newsImage}
                alt={item.title}
                className="absolute top-0 left-0 w-full h-full object-contain bg-gray-100" 
                // object-contain：完整显示图片，不裁剪；bg-gray-100：填充图片周围留白
              />
              {/* 右上角日期卡片位置保持不变 */}
              <div className="absolute top-[clamp(0.75rem,1.5vw,1rem)] right-[clamp(0.75rem,1.5vw,1rem)] bg-white/90 backdrop-blur-sm rounded-lg p-[clamp(0.5rem,1vw,0.75rem)] text-center">
                <div className="text-[clamp(1rem,2vw,1.25rem)] font-bold text-gray-900">{item.date.day}</div>
                <div className="text-[clamp(0.625rem,1vw,0.75rem)] text-gray-600">{item.date.month}</div>
                <div className="text-[clamp(0.625rem,1vw,0.75rem)] text-gray-600">{item.date.year}</div>
              </div>
            </div>
            {/* 主要新闻内容保持不变 */}
            <div className="p-[clamp(1rem,2vw,1.5rem)]">
              <h3 className="text-[clamp(1rem,2vw,1.25rem)] font-bold text-gray-900 mb-[clamp(0.75rem,1.5vw,1rem)] leading-tight line-clamp-2">
                {item.title}
              </h3>
              <p className="text-gray-600 mb-[clamp(0.75rem,1.5vw,1rem)] leading-relaxed text-[clamp(0.8125rem,1.2vw,0.875rem)]">
                {item.excerpt}
              </p>
              <a
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-[clamp(0.25rem,0.5vw,0.5rem)] text-[#4677e0] font-semibold hover:text-blue-700 transition-colors cursor-pointer"
              >
                <span className="text-[clamp(0.8125rem,1.2vw,0.875rem)]">阅读全文</span>
                <i className="ri-arrow-right-line text-[clamp(0.75rem,1vw,0.875rem)]"></i>
              </a>
            </div>
          </div>
        ))}
      </div>

      {/* 新闻列表（右侧）保持不变 */}
      <div className="lg:col-span-7 mt-8 lg:mt-0">
        <div className="bg-white rounded-3xl p-[clamp(1rem,2vw,1.5rem)] shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
          <div className="space-y-[clamp(1rem,2vw,1.5rem)]">
            {news.filter(item => !item.featured).slice(0, 3).map((item, index) => (
              <div key={index} className="border-b border-gray-100 pb-[clamp(1rem,2vw,1.5rem)] last:border-b-0 last:pb-0">
                <div className="flex items-start space-x-[clamp(0.75rem,1.5vw,1rem)]">
                  <div className="flex-shrink-0">
                    <div className="bg-gray-100 rounded-lg p-[clamp(0.5rem,1vw,0.75rem)] text-center min-w-[clamp(50px,10vw,60px)]">
                      <div className="text-[clamp(0.875rem,1.5vw,1rem)] font-bold text-gray-900">{item.date.day}</div>
                      <div className="text-[clamp(0.625rem,1vw,0.75rem)] text-gray-600">{item.date.month}</div>
                      <div className="text-[clamp(0.625rem,1vw,0.75rem)] text-gray-600">{item.date.year}</div>
                    </div>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-[clamp(0.9375rem,1.8vw,1.125rem)] font-bold text-gray-900 mb-[clamp(0.5rem,1vw,0.75rem)] hover:text-[#4677e0] transition-colors cursor-pointer line-clamp-2">
                      <a href={item.link} target="_blank" rel="noopener noreferrer">
                        {item.title}
                      </a>
                    </h4>
                    <p className="text-gray-600 text-[clamp(0.75rem,1.2vw,0.8125rem)] leading-relaxed mb-[clamp(0.5rem,1vw,0.75rem)]">
                      {item.excerpt}
                    </p>
                    <a
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center space-x-[clamp(0.25rem,0.5vw,0.5rem)] text-[#4677e0] text-[clamp(0.75rem,1.2vw,0.8125rem)] font-medium hover:text-blue-700 transition-colors cursor-pointer"
                    >
                      <span>查看详情</span>
                      <i className="ri-arrow-right-line text-[clamp(0.625rem,1vw,0.75rem)]"></i>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>

    {/* 微信公众号关注区 */}
    <div className="mt-10 md:mt-16">
      <div className="relative rounded-3xl bg-gradient-to-br from-[#386bd5] via-[#4677e0] to-[#2456bc] p-6 text-white shadow-xl shadow-blue-900/10 sm:p-8 lg:p-10">
        <div className="grid items-center gap-8 lg:grid-cols-[minmax(0,1fr)_auto] lg:gap-12">
          <div className="min-w-0">
            <div className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-white/15 ring-1 ring-white/25">
              <i className="ri-wechat-fill text-2xl" aria-hidden="true"></i>
            </div>
            <h3 className="mb-3 text-[clamp(1.5rem,2.5vw,2rem)] font-bold leading-tight">关注我们的微信公众号</h3>
            <p className="max-w-2xl text-sm leading-relaxed text-blue-50 sm:text-base">
              获取更多企业动态、技术资讯和行业洞察，第一时间了解万江环境科技的最新发展
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-3">
              <div className="inline-flex min-h-11 items-center gap-2 rounded-xl bg-white/15 px-4 py-2 text-sm font-semibold ring-1 ring-white/20 sm:text-base">
                <i className="ri-wechat-fill text-lg" aria-hidden="true"></i>
                <span>上海万江环境科技有限公司</span>
              </div>
              <div className="group relative">
                <button type="button" aria-describedby="news-qr-popup" className="inline-flex min-h-11 items-center gap-2 rounded-xl bg-white px-4 py-2 text-sm font-semibold text-[#2456bc] transition-colors hover:bg-blue-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white sm:text-base">
                  <i className="ri-qr-code-line text-lg" aria-hidden="true"></i>
                  <span>扫码关注</span>
                </button>
                <div id="news-qr-popup" role="tooltip" className="absolute bottom-full left-0 z-20 mb-3 hidden rounded-2xl bg-white p-4 text-center shadow-2xl group-hover:block group-focus-within:block">
                  <img src={wxContactImage} alt="微信公众号二维码" className="h-36 w-36 max-w-none rounded-lg object-contain" />
                  <p className="mt-2 whitespace-nowrap text-sm font-medium text-gray-600">微信扫码关注</p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-center lg:justify-end">
            <div className="rounded-2xl bg-white p-4 text-center shadow-lg shadow-blue-950/20">
              <img src={wxContactImage} alt="微信公众号二维码" className="mx-auto h-36 w-36 rounded-lg object-contain sm:h-40 sm:w-40" />
              <p className="mt-2 text-sm font-medium text-gray-600">微信扫码关注</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
  );
}
